/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceOverviewEntryResponse } from './AttendanceOverviewEntryResponse';
import {
    AttendanceOverviewEntryResponseFromJSON,
    AttendanceOverviewEntryResponseFromJSONTyped,
    AttendanceOverviewEntryResponseToJSON,
    AttendanceOverviewEntryResponseToJSONTyped,
} from './AttendanceOverviewEntryResponse';

/**
 * 
 * @export
 * @interface AttendanceOverviewRowResponse
 */
export interface AttendanceOverviewRowResponse {
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewRowResponse
     */
    counselorId: string;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewRowResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewRowResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewRowResponse
     */
    lastName: string;
    /**
     * 
     * @type {Array<AttendanceOverviewEntryResponse>}
     * @memberof AttendanceOverviewRowResponse
     */
    entries: Array<AttendanceOverviewEntryResponse>;
}

/**
 * Check if a given object implements the AttendanceOverviewRowResponse interface.
 */
export function instanceOfAttendanceOverviewRowResponse(value: object): value is AttendanceOverviewRowResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function AttendanceOverviewRowResponseFromJSON(json: any): AttendanceOverviewRowResponse {
    return AttendanceOverviewRowResponseFromJSONTyped(json, false);
}

export function AttendanceOverviewRowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceOverviewRowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'userCode': json['userCode'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'entries': ((json['entries'] as Array<any>).map(AttendanceOverviewEntryResponseFromJSON)),
    };
}

export function AttendanceOverviewRowResponseToJSON(json: any): AttendanceOverviewRowResponse {
    return AttendanceOverviewRowResponseToJSONTyped(json, false);
}

export function AttendanceOverviewRowResponseToJSONTyped(value?: AttendanceOverviewRowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'userCode': value['userCode'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'entries': ((value['entries'] as Array<any>).map(AttendanceOverviewEntryResponseToJSON)),
    };
}

